import { render, staticRenderFns } from "./depament.vue?vue&type=template&id=2247685e&scoped=true&"
import script from "./depament.vue?vue&type=script&lang=js&"
export * from "./depament.vue?vue&type=script&lang=js&"
import style0 from "./depament.vue?vue&type=style&index=0&id=2247685e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2247685e",
  null
  
)

export default component.exports